// extracted by mini-css-extract-plugin
export var labelWrapper = "StyledLabel-module--label-wrapper--2RwtJ";
export var labelWrapperRound = "StyledLabel-module--label-wrapper-round--3E8lX";
export var labelText = "StyledLabel-module--label-text--30P85";